// extracted by mini-css-extract-plugin
export default {"addBtn":"ShipmentSection_addBtn__dDhRa"};